module.exports = __webpack_public_path__ + "img/htgl.3fa5cad3.png";